import { render, staticRenderFns } from "./loginJournal.vue?vue&type=template&id=1ba9197e&scoped=true"
import script from "./loginJournal.vue?vue&type=script&lang=js"
export * from "./loginJournal.vue?vue&type=script&lang=js"
import style0 from "./loginJournal.vue?vue&type=style&index=0&id=1ba9197e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba9197e",
  null
  
)

export default component.exports